import { render, staticRenderFns } from "./RateForGroupModal.vue?vue&type=template&id=2fcd0bb2&scoped=true"
import script from "./RateForGroupModal.vue?vue&type=script&lang=js"
export * from "./RateForGroupModal.vue?vue&type=script&lang=js"
import style0 from "./RateForGroupModal.vue?vue&type=style&index=0&id=2fcd0bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd0bb2",
  null
  
)

export default component.exports